import * as seedrandom from "seedrandom";



export class RND {
    rnd: seedrandom.PRNG;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(seed: string) {
        this.rnd = seedrandom(seed);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    random(): number {
        return this.rnd();
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci float v rozsahu min az max
     * @param min 
     * @param max 
     * @returns 
     */
    //-------------------------------------------------------------------------
    randomIn(min: number, max: number): number {
        return min + this.rnd() * (max - min);
    }

    //-------------------------------------------------------------------------
    /**
     * Vraci integer v rozsahu min az max (vcetne)
     * @param min 
     * @param max 
     * @returns 
     */
    //-------------------------------------------------------------------------
    randomIntIn(min: number, max: number): number {
        return min + Math.floor(this.rnd() * (max - min + 1));
    }

    //-------------------------------------------------------------------------
    /**
     * 
     * @returns Vraci true nebo false
     */
    //-------------------------------------------------------------------------
    randomBool(): boolean {
        return this.randomIn(0, 1) >= 0.5;
    }

    //-------------------------------------------------------------------------
    /**
     * Vyber prvku pole s pouzitim priority vyberu pro jednotlive prvky
     * @param priorities Pole s prioritami vyberu pro jednotlive prvky. Prvek musi mit prioritu > 0, aby byl zarazen do vyberu
     * @param resetSelTo Hodnota priority, na kterou ma byt resetovat vybrany prvek
     * @param incUnsel True, pokud ma byt navysena priorita nevybranych prvku
     * @returns Vraci index vybraneho prvku
     */
    //-------------------------------------------------------------------------
    choiceWithPriority(priorities: number[], resetSelTo: number = 0, incUnsel: boolean = true): number {
        // Soucet vsech priorit
        let sum = 0;
        let i = priorities.length;

        while (i-- != 0) {
            let p = priorities[i];

            if (p > 0)
                sum += p;
        }

        // Vybrat
        let res: number;

        if (sum != 0) {
            let sel = this.randomIntIn(0, sum - 1);

            i = priorities.length;

            while (i-- != 0) {
                let p = priorities[i];

                if (p > 0) {
                    if (p > sel) {
                        res = i;

                        // Resetovat prioritu vybrane polozky
                        priorities[i] = resetSelTo;
                        break;
                    }

                    sel -= p;
                }
            }
        }
        else {
            res = this.randomIntIn(0, priorities.length - 1);
        }

        // Navysit prioritu nevybranych polozek
        if (incUnsel) {
            i = priorities.length;

            while (i-- != 0)
                if (i != res)
                    priorities[i]++;
        }

        return res;
    }
}